export default __webpack_public_path__ + "static/media/ba16.7a4d38ba.jpg";